import client from '../utils/client'
import { gql } from '@apollo/client'

import { MutationHandlerResult } from '../utils/errors'

const UPDATE_RESTAURANT_BASE_DATA = gql`
	mutation UpdateRestaurantBaseData($restaurantId: ID!, $input: UpdateRestaurantBaseDataInput!) {
		updateRestaurantBaseData(restaurantId: $restaurantId, input: $input) {
			success
		}
	}
`

// Titel, Anschrift, Koordinaten und Kontakt des Restaurants; leere Pflichtfelder lässt die API stehen.
const updateRestaurantBaseData = async ({
	restaurantId,
	input,
}: {
	restaurantId: string
	input: Record<string, string | null>
}): Promise<MutationHandlerResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: UPDATE_RESTAURANT_BASE_DATA,
			variables: { restaurantId, input },
			errorPolicy: 'all',
			refetchQueries: ['CurrentUser'],
		})

		return errors ? { success: false, errors } : { success: true, errors: null }
	} catch (e: unknown) {
		if (e && typeof e === 'object' && 'networkError' in e)
			return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default updateRestaurantBaseData
